import {
  OUT_OF_STOCK_FORM_ERROR,
  OUT_OF_STOCK_FORM_SUCCESS,
  OUT_OF_STOCK_FORM_VIEW,
  OUT_OF_STOCK_POPUP_STATE_CLOSE,
  OUT_OF_STOCK_POPUP_STATE_OPEN,
  OUT_OF_STOCK_SENT,
  OUT_OF_STOCK_STORAGE_DATA,
  TOOGLE_AGREEMENT_FIELD_DATA,
} from './constants';

const initialState = {
  agreementUncheckedState: {},
  header: 'Оставьте свой E-mail',
  outOfStockOpenState: false,
  storageData: '',
  viewState: OUT_OF_STOCK_FORM_VIEW,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case OUT_OF_STOCK_STORAGE_DATA: {
      return {
        ...state,
        storageData: action.payload,
      };
    }
    case OUT_OF_STOCK_POPUP_STATE_OPEN: {
      const { article, outOfStockOpenState, productId, viewState } = action;
      return {
        ...state,
        article,
        outOfStockOpenState,
        productId,
        viewState,
      };
    }
    case OUT_OF_STOCK_POPUP_STATE_CLOSE: {
      const { outOfStockOpenState } = action;
      return {
        ...state,
        outOfStockOpenState,
      };
    }
    case TOOGLE_AGREEMENT_FIELD_DATA: {
      return {
        ...state,
        agreementUncheckedState: {
          ...state.agreementUncheckedState,
          ...{ ...action.payload },
        },
      };
    }
    case OUT_OF_STOCK_SENT: {
      return {
        ...state,
        isOutOfStockSent: true,
      };
    }
    // Создать массив использованных ид
    case OUT_OF_STOCK_FORM_SUCCESS: {
      const { viewState } = action;
      return {
        ...state,
        isOutOfStockSent: true,
        viewState,
      };
    }
    case OUT_OF_STOCK_FORM_ERROR: {
      const { message, viewState } = action;
      return {
        ...state,
        errorFetchedMessage: typeof message === 'string' ? message : '',
        // outOfStockOpenState,
        viewState,
      };
    }
    default:
      return state;
  }
}
